import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PreciosService {

  private endpoint: string | null;

  constructor
  (
    private httpClient: HttpClient
  ) 
  { 
    this.endpoint = Base64.decode(environment.apiEndpoint) + '/precios/Precios';
  }

  getPrecios(tipo: string) {
    return this.httpClient.get(this.endpoint + `/GetPrecios/${tipo}`);
  }

  insertPrecioCombustible(request: any, tipoCombustible: string){
    return this.httpClient.post(this.endpoint + `/InsertPrecio${tipoCombustible}`, request);
  }

  getPreciosActuales(){
    return this.httpClient.get(this.endpoint + `/GetPreciosActuales`);
  }
}
